///////////////////////////////////////////////////////////////
// lazyloaded event to pass isLoaded css class to <picture>
///////////////////////////////////////////////////////////////
document.addEventListener('lazyloaded', function(e){
    var imgLoaded = $(e.target).parent();
    var prodImgLoaded = $(e.target).parent('picture').parent('.carousel-slide');
    var prodVidLoaded = $(e.target).parent('.carousel-slide');
    prodImgLoaded.addClass('isLoaded');

    setTimeout(function() {
        imgLoaded.removeClass('isDelayed');
        prodImgLoaded.removeClass('isDelayed');
        prodVidLoaded.removeClass('isDelayed');
    }, 100);
});